<template>
  <div style="height: 100%;">
    <iframe-top-operation
      ref="iframeTopOperation"
      v-if="showTopOperation"
      :showBackButton="getShowBackButton"
    >
    </iframe-top-operation>
    <div class="mainIframe">
      <iframe ref="mainIframe"
              v-show="active"
              :id="uuid"
              frameborder="0"
              :name="iframeName"
              scrolling="auto"
              :src="finalIframeUrl"
              :width="tBodyWidth"
              :height="tBodyHeight"
              :style="styleObject">
      </iframe>
    </div>
  </div>
</template>
<script>
  import IframeTopOperation from './iframe-top-operation.vue'
  import { v4 as uuidv4 } from 'uuid'

  export default {
    components: {
      IframeTopOperation
    },
    name: 'common-iframe',
    props: {
      showBackButton: {
        type: Boolean,
        default: false
      },
      showTopOperation: {
        type: Boolean,
        default: false
      },
      bindRouteUrl: {
        type: Boolean,
        default: true
      },
      iframeUrl: {
        type: String,
        default: ''
      },
      iframeName: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        uuid: null,
        tBodyHeight: 200,
        tBodyWidth: '100%',
        offsetLeft: null,
        offsetTop: null,
        // iframe是否显示
        active: true,
        // 宽高自适应定时器
        intervalId: null,
        // 是否激活自动调整宽高
        enableAutoHeight: false,
        // 绑定在路由上的iframeUrl
        routeIframeUrl: null,
        styleObject: {}
      }
    },
    computed: {
      getShowBackButton: function () {
        return this.showBackButton
      },
      finalIframeUrl: function () {
        if (this.iframeUrl) {
          return this.iframeUrl
        }
        return this.routeIframeUrl
      }
    },
    activated() {
      this.active = true
      this.enableAutoHeight = true
    },
    deactivated() {
      this.active = false
      // 方防止路由切换后iframe高度和宽度变为0，影响展示效果
      this.enableAutoHeight = false
    },
    created() {
      this.uuid = 'iframe_' + uuidv4()
      if (this.bindRouteUrl) {
        this.routeIframeUrl = this.$route.meta.url
      }
    },
    mounted() {
      this.iframeId = this.$route.meta.permissionId
      // 将iframe移动到div#app下，防止切换路由时iframe被销毁了
      document.querySelector('div#app').appendChild(this.$refs['mainIframe'])
      // 开启高度自适应定时器
      this.intervalId = setInterval(() => this.tBodyAutoHeight(), 200)
    },
    beforeDestroy() {
      // 删除iframe
      document.querySelector('div#app').removeChild(this.$refs['mainIframe'])
      // 清楚高度自适应定时器
      clearInterval(this.intervalId)
    },
    methods: {
      tBodyAutoHeight() {
        if (!this.enableAutoHeight) {
          return
        }
        // iframe定位
        let offsetParent = this.$el.offsetParent
        if (offsetParent) {
          this.offsetLeft = offsetParent.offsetLeft + 'px'
          this.offsetTop = offsetParent.offsetTop + 'px'
        }
        this.styleObject = {position: 'absolute'}
        if (this.offsetLeft) {
          this.styleObject.left = this.offsetLeft
        }
        if (this.offsetTop) {
          this.styleObject.top = this.offsetTop
        }
        // iframe宽高自适应
        let topOperationHeight = this.$refs.iframeTopOperation ? this.$refs.iframeTopOperation.$el.offsetHeight : 0
        this.tBodyWidth = this.$el.clientWidth
        this.tBodyHeight = this.$el.offsetHeight - topOperationHeight
      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/components/iframe/iframe.vue